const { connect } = require('react-redux')
const agents = require('../../../_plugins/lib/agents')

const mapStateToProps = state => {
  return {
    agentData: state.agentData
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  agents.props = ownProps
  const updateAgentData = data => {
    dispatch({
      type: 'UPDATE',
      data: agents.updateAgentData(data)
    })
  }
  const getAgent = () => {
    return agents.getAgent()
  }
  const agentSetup = (agent = getAgent()) => {
    if (agent !== agents.getDefaultAgent()) return updateAgent(agent)
    updateAgentData(agents.getInitialState())
  }
  const updateAgent = agent => {
    agents.checkAgent(agent, updateAgentData)
  }
  return {
    updateAgentData,
    agentSetup,
    getAgent,
    updateAgent
  }
}

const connectedComponent = (WrappedComponent) => connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedComponent)

module.exports = connectedComponent
